import { InputNumber } from 'primereact/inputnumber';
import { useEffect, useState } from "react";

function NumberEditor({
    data,
    label,
    placeholder,
    onBlur,
    message,
    attr,
    ...props
}) {
    const [value, setValue] = useState(data?.[attr]);

    function onChange(e) {
        let val = e.value;
        // округляем до двух знаков после запятой
        if (typeof val === "number") {
            val = parseFloat(val.toFixed(2));
        }
        setValue(val);
        onBlur(e, attr, val);
    }

    useEffect(() => {
        if (typeof data?.[attr] === "number") {
            setValue(parseFloat(data[attr].toFixed(2)));
        } else {
            setValue(data?.[attr]);
        }
    }, [data?.[attr]]);

    return (
        <div className="flex justify-content-center">
            <div className="editor">
                <label className="editor_label" htmlFor={label}>{label}</label>
                <InputNumber
                    id={label}
                    className="p-inputtext-dd"
                    aria-describedby="username-help"
                    value={value}
                    onChange={onChange}
                    onInput={onChange}
                    minFractionDigits={2}  // минимум 2 знака
                    maxFractionDigits={2}  // максимум 2 знака
                    mode="decimal"
                    placeholder={placeholder}
                    {...props}
                />
                {message && (
                    <small id="username-help">{message}</small>
                )}
            </div>
        </div>
    );
}

export default NumberEditor;
